import { useRequiredContext } from "@redotech/react-util/context";
import DataFlow from "@redotech/redo-icons/dataflow-03.svg";
import DataFlowFilled from "@redotech/redo-icons/dataflow-03_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";

export const AutomationsItems = memo(function AutomationsItems() {
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.automationsHref }}
      FilledIcon={DataFlowFilled}
      friendlyName="Automations"
      id="automations"
      UnfilledIcon={DataFlow}
    />
  );
});
